import { getImageUrl } from '../../config/Config';
import ImagesItemMenu from './ImagesItemMenu';
import { CONTENT_TYPES } from '../../services/DrawingsService.ts';
import { cn } from 'nayan';

interface Props {
  image: any;
  category: any;
}

const ImagesItem = (props: Props) => {
  const { image, category } = props;

  return (
    <div className="p-3 bg-card border-border border rounded cursor-pointer">
      <div className="h-[0px] overflow-hidden relative mb-3" style={{ paddingTop: '100%' }}>
        <img
          src={getImageUrl(image.file)}
          className={`absolute top-0 left-0 w-full h-full ${category.content === CONTENT_TYPES.IMAGES ? 'object-contain' : 'object-cover'}`}
          alt={image.name}
        />
      </div>
      <div className="flex justify-between items-center mb-1">
        <div className="text-base flex-1 line-clamp-1">
          {image.priority > 0 ? image.priority + '. ' : ''}
          {image.name}
        </div>
        <ImagesItemMenu category={category} image={image} />
      </div>
      {category.content !== CONTENT_TYPES.PUZZLES && <div className="text-sm leading-relaxed">{image.details}</div>}
      {category.content === CONTENT_TYPES.PUZZLES && (
        <div className="">
          {image.options.map((o: any) => (
            <div key={o.id} className={cn('text-sm leading-relaxed', o.checked ? 'font-bold' : '')}>
              {o.id}. {o.name}
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default ImagesItem;
